import { ActivityConfig, AvailableInstance, IntegrationsMappedOptions } from '@/types/integrations.types';
import ActivityIntegrationMapping from './activity-mapping';
import StaticIntegrationMapping from './static-mapping';

interface ActivityIntegrationFormProps {
  onChange: ({
    activityMapping,
    staticMapping,
    valid,
  }: {
    activityMapping?: Record<string, ActivityConfig>;
    staticMapping?: Record<string, string>;
    valid?: boolean;
  }) => void;
  instance: AvailableInstance;
  values?: IntegrationsMappedOptions;
  edit: boolean;
  isOverrideMapping?: boolean;
}

function ActivityIntegrationForm({
  onChange,
  instance,
  values,
  edit,
  isOverrideMapping,
}: ActivityIntegrationFormProps) {
  const handleSetActivityMapping = (activityMapping: Record<string, ActivityConfig>) => {
    onChange({
      activityMapping,
    });
  };

  const handleSetStaticMapping = ({
    staticMapping,
    valid,
  }: {
    staticMapping: Record<string, string>;
    valid: boolean;
  }) => {
    onChange({
      staticMapping,
      valid,
    });
  };

  return (
    <>
      <ActivityIntegrationMapping
        integration={instance}
        edit={edit}
        setActivityMapping={handleSetActivityMapping}
        isOverrideMapping={isOverrideMapping}
        values={values}
      />
      <StaticIntegrationMapping integration={instance} onChange={handleSetStaticMapping} overrides={values} />
    </>
  );
}

export default ActivityIntegrationForm;
